import { format } from 'date-fns';
import { dateFormatWithZeroMillisecond } from '80.quickConnect.Core/helpers/dateFormat';

const parseTimeToAPI = (date: Date): string => {
  const dateFormatted = format(date, dateFormatWithZeroMillisecond);
  return dateFormatted.replace(dateFormatted.substring(0, dateFormatted.indexOf('T')), '1970-01-01');
};

export default parseTimeToAPI;
